<template>
  <div id="about">
    <!-- 头部图片 -->
    <div class="banner">
      <div class="">
        <div class="text">奥创工作手机</div>
        <div class="text">企业微营销必备工具</div>
      </div>
    </div>
    <!-- 接触奥创前 -->
    <div class="ac_before">
      <div class="title">“接触奥创前，他们也曾和你一样”</div>
      <div class="content phone">
        <div class="text-wrap">
          <span class="text text_1">
            <span>
              <span class="">跨地区运营，大量手机微信，分散性销售</span>
              <span class="red">团队管理难</span>
            </span>
          </span>
          <span class="text text_2">
            <span>
              <span class="">销售离职工作不交接，聊天记录和跟踪进度缺失，</span>
              <span class="red">客户流失</span>
            </span>
          </span>
          <span class="text text_3">
            <span>
              <span class="">销售私加客户，私自拉群，倒卖公司客户资源，</span>
              <span class="red">飞单接私活</span>
            </span>
          </span>
          <span class="text text_4">
            <span>
              <span class="">客服回复消息慢，回答不专业，优秀</span>
              <span class="red">话术难传达</span>
              <span class="">，影响品牌形象</span>
            </span>
          </span>
          <span class="text text_5">
            <span>
              <span>辱骂客户，违规承诺，夸大宣传引发客诉，</span>
              <span class="red">品牌口碑崩塌</span>
            </span>
          </span>
          <span class="text text_6">
            <span>
              <span class="">客服加粉数、聊天数、电话量需手动统计难，</span>
              <span class="red">绩效考核困难</span>
            </span>
          </span>
          <span class="text text_7">
            <span>
              <span class="red">客户分配不均</span>
              <span class="">，长期不成交的客户，不能重新分配销售跟进</span>
            </span>
          </span>
          <span class="text text_8">
            <span>
              <span class="">客服忘记发朋友圈，或发送质量差，</span>
              <span class="red">无法对外整体形象输出</span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <!-- 接触奥创后 -->
    <div class="ac_now">
      <div class="ac_now_wrap">
        <div class="title">
          <span class="">但在奥创，他们找到了解决的法门</span>
        </div>
        <div class="info-native">
          <div class="phone"
               :class="{'active': activeProduct === 1}"
               @click="activeProduct = 1">
            <span class="icon icon-phone"></span>
            <span class="text-title">专用手机</span>
          </div>
          <div class="user"
               :class="{'active': activeProduct === 2}"
               @click="activeProduct = 2">
            <span class="icon icon-user"></span>
            <span class="text-title">前台客服</span>
          </div>
          <div class="setting"
               :class="{'active': activeProduct === 3}"
               @click="activeProduct = 3">
            <span class="icon icon-setting"></span>
            <span class="text-title">后台管理</span>
          </div>
        </div>
        <div class="info-content">
          <div class="list-wrap" :class="'active_'+activeProduct">
            <div class="info-wrap" v-for="n in 3" :key="n">
              <div class="image-wrap">
                <div class="left-image">
                  <div class="r_b_image image">
                    <span class="text-title"><span class="title-sign">{{traitList[n-1].a.title}}</span></span>
                    <span class="text-content">{{traitList[n-1].a.text}}</span>
                  </div>
                  <div class="r_t_image image">
                    <span class="text-title"><span class="title-sign">{{traitList[n-1].b.title}}</span></span>
                    <span class="text-content">{{traitList[n-1].b.text}}</span>
                  </div>
                </div>
                <div class="middle-image" :class="['one-img','two-img','three-img'][n-1]"></div>
                <div class="right-image">
                  <div class="l_b_image image">
                    <span class="text-title"><span class="title-sign">{{traitList[n-1].c.title}}</span></span>
                    <span class="text-content">{{traitList[n-1].c.text}}</span>
                  </div>
                  <div class="l_t_image image">
                    <span class="text-title"><span class="title-sign">{{traitList[n-1].d.title}}</span></span>
                    <span class="text-content">{{traitList[n-1].d.text}}</span>
                  </div>
                </div>
              </div>
              <div class="info-text">
                <template v-if="activeProduct === 1">
                  <div class="text-title">专用手机</div>
                  <div class="text-content">为员工配备专用工作手机，严防离职带走公司资源</div>
                </template>
                <template v-else-if="activeProduct === 2">
                  <div class="text-title">前台客服</div>
                  <div class="text-content">多号一聊、一号多聊、多号公聊、自由转接客户，高效提升客户转化率</div>
                </template>
                <template v-else>
                  <div class="text-title">后台管理</div>
                  <div class="text-content">管理员通过后台对系统进行权限分配、系统设置、各类违规操作和敏感行为的查看和处理，以及各类数据的统计和分析</div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="trait-wrap">
          <div class="trait">
            <span class="wrap">
              <span class="text-title"><span class="title-sign">{{traitList[activeProduct-1].a.title}}</span></span>
              <span class="text-content">{{traitList[activeProduct-1].a.text}}</span>
            </span>
          </div>
          <div class="trait">
            <span class="wrap">
              <span class="text-title"><span class="title-sign">{{traitList[activeProduct-1].b.title}}</span></span>
              <span class="text-content">{{traitList[activeProduct-1].b.text}}</span>
            </span>
          </div>
          <div class="trait">
            <span class="wrap">
              <span class="text-title"><span class="title-sign">{{traitList[activeProduct-1].c.title}}</span></span>
              <span class="text-content">{{traitList[activeProduct-1].c.text}}</span>
            </span>
          </div>
          <div class="trait">
            <span class="wrap">
              <span class="text-title"><span class="title-sign">{{traitList[activeProduct-1].d.title}}</span></span>
              <span class="text-content">{{traitList[activeProduct-1].d.text}}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 客户端 -->
    <div v-show="activeProduct === 1" class="ac_secret">
      <div class="secret secret_1">
        <div class="left clint"></div>
        <div class="right">
          <div class="text-title">客户资料保密</div>
          <div class="text">1、员工无法看到客户微信号和手机号，推送名片操作将预警；</div>
          <div class="text">2、制定APP下载，限制员工试用沟通工具部分功能！防止客户流失；</div>
        </div>
      </div>
      <div class="secret secret_2">
        <div class="left clint"></div>
        <div class="right">
          <div class="text-title">数据二重保护</div>
          <div class="text">1、如果因做营销被封号无法登陆，可通过后台查看好友数据重新添加；</div>
          <div class="text">2、员工拉黑、删除客户，管理员将收到提醒；</div>
        </div>
      </div>
      <div class="secret secret_3">
        <div class="left clint"></div>
        <div class="right">
          <div class="text-title">防止销售撞单</div>
          <div class="text">1、系统将自动筛选出企业工作号中的重复好友，以便处理；</div>
          <div class="text">2、客服沟通客户过程中，如该好友已添加其他客服账号，将通知；</div>
        </div>
      </div>
      <div class="secret secret_4">
        <div class="left clint"></div>
        <div class="right">
          <div class="text-title">客户智能分组</div>
          <div class="text">1、可将当下最流行的个人号聊天工具中好友进行分组管理</div>
          <div class="text">2、可帮助客服实现一号多聊，多号一聊</div>
        </div>
      </div>
    </div>
    <!-- 工作手机 -->
    <div v-show="activeProduct === 2" class="ac_secret">
      <div class="secret secret_1">
        <div class="left service"></div>
        <div class="right">
          <div class="text-title">多账号集中管理</div>
          <div class="text">1、多账号集中对话，可同时接待回复多个账号好友的消息；</div>
          <div class="text">2、无需扫码，一次登录永久在线，支持手机和账号异地；</div>
        </div>
      </div>
      <div class="secret secret_2">
        <div class="left service"></div>
        <div class="right">
          <div class="text-title">销售话术标准化</div>
          <div class="text">1、通过快捷回复及自动化回复功能，销售响应客户更快、更及时、更专业</div>
          <div class="text">2、筛选优秀成交话术，批量分享给他人，销售团队迅速成长，全面提升业绩；</div>
        </div>
      </div>
      <div class="secret secret_3">
        <div class="left service"></div>
        <div class="right">
          <div class="text-title">自动规模化营销</div>
          <div class="text">1、可多维度交叉精准筛选受众好友，一键推送消息，精准触达；</div>
          <div class="text">2、可对多个号同步推送朋友圈内容，导入列表自动加好友；</div>
        </div>
      </div>
      <div class="secret secret_4">
        <div class="left service"></div>
        <div class="right">
          <div class="text-title">与CRM资料同步</div>
          <div class="text">1、公司CRM中的客户资料可直接展现，知己知彼百战不殆；</div>
          <div class="text">2、在工作台给客户添加的标签和备注等将直接同步到CRM系统；</div>
        </div>
      </div>
    </div>
    <!-- 管理端 -->
    <div v-show="activeProduct === 3" class="ac_secret service-block">
      <div class="secret secret_1">
        <div class="left manage"></div>
        <div class="right">
          <div class="text-title">客户数据统一管理</div>
          <div class="text">1、公司客户资源统一存进私域流量客户管理系统，防止员工带走公司客户资料；</div>
          <div class="text">2、针对私域流量的好友拥有多维度标签画像，以及完善的客户资料；</div>
        </div>
      </div>
      <div class="secret secret_2">
        <div class="left manage"></div>
        <div class="right">
          <div class="text-title">客户沟通全程可视化</div>
          <div class="text">1、客服聊天内容、电话录音、手机短信实时同步上传至管理员后台；</div>
          <div class="text">2、管理员/质检人员，可随时随地从后台，对客服沟通内容进行质检；</div>
        </div>
      </div>
      <div class="secret secret_3">
        <div class="left manage"></div>
        <div class="right">
          <div class="text-title">敏感词、敏感操作预警</div>
          <div class="text">1、系统自动拦截包含敏感关键词的消息，防止涉及违禁词汇被封号；</div>
          <div class="text">2、客服沟通客户过程中，如该好友已添加其他客服账号，将通知；</div>
        </div>
      </div>
      <div class="secret secret_4">
        <div class="left manage"></div>
        <div class="right">
          <div class="text-title">客户重新再分配</div>
          <div class="text">1、客服回复不及时，或长期不能转化客户，无需重新加好友，可直接分配给他人跟进；</div>
          <div class="text">2、删好友，删聊天记录，红包转账等58项敏感行为风控，降低风险；</div>
        </div>
      </div>
      <div class="secret secret_5">
        <div class="left manage"></div>
        <div class="right">
          <div class="text-title">数据统计分析</div>
          <div class="text">1、精准统计客户添加数量，有效评估广告投放效果，便于制定营销计划；</div>
          <div class="text">2、对话数量、相应时间等多维度数据统计，可反应客服工作能力及工作态度；</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Index from './main'

export default {
  name: 'phone',
  ...Index
}
</script>
<style lang="scss">
  @import "./index";
</style>
